/**
 * Open a URL in a new tab. Returns false when blocked (popup blocker).
 * @param {string} url
 * @param {{ open?: typeof window.open }} [deps]
 * @returns {boolean}
 */
export function openExternalTab(url, deps) {
  if (!url || typeof window === "undefined") return false;
  const openFn = deps?.open ?? window.open.bind(window);
  const opened = openFn(url, "_blank", "noopener,noreferrer");
  return opened != null;
}
